import Vue from 'vue'
import ut from '@/utils'

import {Resource} from 'vue-resource'

const Transport = {
  id: null,
  model: '',
  number: '',
  driver_staff: null,
}

const TransportResource = new Resource('/', {}, {
  list: {
    method: 'GET',
    url: 'transport/list/',
  },
  details: {
    method: 'GET',
    url: 'transport/detail/{id}/',
  },
  history: {
    method: 'GET',
    url: 'transport/operations/list/',
  },
  create: {
    method: 'POST',
    url: 'transport/create/',
  },
  update: {
    method: 'PUT',
    url: 'transport/update/{id}/',
  },
  remove: {
    method: 'DELETE',
    url: 'transport/delete/{id}/',
  },
})

export default {
  namespaced: true,

  state: {
    data: null,
    fetching: false,
    model: ut.deepClone(Transport),

    saving: false,
    deleting: {},

    fetchingHistory: false,
    history: null,
  },

  getters: {
    getTransport: (state) => (id) => state.data?.results?.find(m => m.id === id),
  },

  mutations: {
    setItems(state, data) {
      state.data = data
    },

    setModel(state, data) {
      state.model = {...ut.deepClone(Transport), ...data}
    },

    setHistory(state, data) {
      state.history = data
    },
  },

  actions: {
    // All transports for selects (e.g. sale document); does not touch the list page state
    fetchOptions() {
      return TransportResource
        .list({limit: 1000})
        .then(({body}) => body.results || [])
    },

    fetch({state, commit}, filters = {}) {
      filters.limit = filters.limit || 1000

      if (!state.fetching) {
        commit('setItems', null)
        state.fetching = TransportResource
                            .list(ut.objFilter(filters))
                            .then((response) => {
                              commit('setItems', response.body)
                            })
                            .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    show({state, commit}, id) {
      if (!state.fetching) {
        commit('setModel', {})
        state.fetching = TransportResource.details({id})
          .then(({body}) => {
            commit('setModel', body)
          })
          .finally(() => state.fetching = false)
      }

      return state.fetching
    },

    fetchHistory({state, commit}, filters = {}) {
      if (!state.fetchingHistory) {
        commit('setHistory', null)
        state.fetchingHistory = TransportResource
                  .history(ut.objFilter(filters))
                  .then((response) => {
                    commit('setHistory', response.body)
                  })
                  .finally(() => state.fetchingHistory = false)
      }

      return state.fetchingHistory
    },

    save({state, commit}) {
      state.saving = true
      let promise
      if (state.model.id) {
        promise = TransportResource.update({id: state.model.id}, state.model)
      } else {
        promise = TransportResource.create(state.model)
      }

      return promise
        .then(({body}) => {
          commit('setModel', body)
        })
        .finally(() => state.saving = false)
    },

    remove({state, dispatch}, id) {
      Vue.set(state.deleting, id, true)
      return TransportResource.remove({id})
        .then(() => dispatch('fetch'))
        .finally(() => Vue.set(state.deleting, id, false))
    },
  },
}
